module.exports = __webpack_public_path__ + "media/images/home/icon-linkedin-7e33adf1f878879777c1a4c49c36dfd8.svg";